import { render, staticRenderFns } from "./GroupsManageModal.vue?vue&type=template&id=285737f8"
import script from "./GroupsManageModal.vue?vue&type=script&lang=js"
export * from "./GroupsManageModal.vue?vue&type=script&lang=js"
import style0 from "./GroupsManageModal.vue?vue&type=style&index=0&id=285737f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports